// src/App.js
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Home from "./pages/Home/Home";
import Header  from "./components/Header";
import Footer from "./components/Footer";
import AboutUs from './pages/Abouts/AboutUs';
import News from "./pages/News/News";
import Inspection from "./pages/Products/Inspection";
import Camera from "./pages/Products/Camera";
import Lighting from "./pages/Products/Lighting";
import Software from "./pages/Products/Software";
import Solutions from "./pages/Products/Solutions";
import ContactPage from "./pages/Contact/Contact";
import Film from "./pages/Solutions/Films";
import Battery from "./pages/Solutions/Battery";
import PCB from "./pages/Solutions/Pcb";
import Fabric from  "./pages/Solutions/Fabric";
import Metals from "./pages/Solutions/Metals";
import Paper from "./pages/Solutions/Paper";
import Energy from "./pages/Solutions/Engery";
import Glass from "./pages/Solutions/Glass";
import Entry from "./pages/Entry/Entry";
import Ultrasonic from "./pages/Ultrasonic/Ultrasonic";
import Measurement from "./pages/Measurement/Measurement";
import Infrared from "./pages/Infrared/Infrared";
import "./App.css";

// 佔位頁（除視覺系統外暫時簡單）
const PlaceholderPage = ({ titleZh, titleEn }) => {
  return (
    <div style={{ padding: '6rem 1.25rem 4rem', minHeight: '60vh' }}>
      <h1 className="text-3xl font-bold mb-4 text-center">{titleZh} / {titleEn}</h1>
      <p className="text-center text-sm text-gray-600">(內容建置中 / Coming soon)</p>
    </div>
  );
};

const AppContent = () => {
  const location = useLocation();
  // 需要隱藏 Header/Footer 的路徑（入口 + 三個獨立介紹頁）
  const hideLayoutPaths = ["/", "/ultrasonic", "/measurement", "/infrared"];
  const hideLayout = hideLayoutPaths.includes(location.pathname);
  return (
    <>
      {!hideLayout && <Header />}
      <Routes>
        {/* 入口頁 */}
        <Route path="/" element={<Entry />} />
        {/* 原首頁改掛在 /visual */}
        <Route path="/visual" element={<Home />} />
        {/* 三個介紹頁顯示獨立圖片（無 Header/Footer） */}
        <Route path="/ultrasonic" element={<Ultrasonic />} />
        <Route path="/measurement" element={<Measurement />} />
        <Route path="/infrared" element={<Infrared />} />
        {/* 既有頁面 */}
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/news" element={<News />} />
        <Route path="/products/inspection" element={<Inspection />} />
        <Route path="/products/camera" element={<Camera />} />
        <Route path="/products/lighting" element={<Lighting />} />
        <Route path="/products/software" element={<Software />} />
        <Route path="/products/solutions" element={<Solutions />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/solutions/film" element={<Film />} />
        <Route path="/solutions/battery" element={<Battery />} />
        <Route path="/solutions/pcb" element={<PCB />} />
        <Route path="/solutions/nonwoven" element={<Fabric />} />
        <Route path="/solutions/metal" element={<Metals />} />
        <Route path="/solutions/paper" element={<Paper />} />
        <Route path="/solutions/solar" element={<Energy />} />
        <Route path="/solutions/glass" element={<Glass />} />
        {/* 捕獲所有不存在的路徑，導回首頁入口 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!hideLayout && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
